import React from 'react';
export function Header() {
  return <header className="w-full border-b border-gray-200 bg-white sticky top-0 z-50" data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-center" data-id="element-175">
        <span className="font-serif text-2xl font-bold tracking-tight text-gray-900" data-id="element-176">
          The Daily <span className="text-brand-sage" data-id="element-177">Chronicle</span>
        </span>
      </div>
    </header>;
}